import { Command, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import {
    AbstractViewContribution,
    CommonMenus,
    FrontendApplication,
    FrontendApplicationContribution
} from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { AnimationsPanel } from './animations-panel';

const AnimationsCommand: Command = { id: 'lvgl-animations:open', label: 'Animations: Open' };

@injectable()
export class AnimationsPanelContribution
    extends AbstractViewContribution<AnimationsPanel>
    implements FrontendApplicationContribution, MenuContribution
{
    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        await this.openView({ activate: false, reveal: false });
    }

    constructor() {
        super({
            widgetId: AnimationsPanel.ID,
            widgetName: AnimationsPanel.LABEL,
            defaultWidgetOptions: { area: 'bottom' },
            toggleCommandId: AnimationsCommand.id
        });
    }

    override registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(AnimationsCommand, {
            execute: async () => {
                const widget = await this.widgetManager.getOrCreateWidget<AnimationsPanel>(AnimationsPanel.ID);
                await this.shell.addWidget(widget, { area: 'bottom' });
                await this.shell.activateWidget(widget.id);
            }
        });
    }

    override registerMenus(menus: MenuModelRegistry): void {
        menus.registerMenuAction(CommonMenus.VIEW_VIEWS, {
            commandId: AnimationsCommand.id,
            label: AnimationsPanel.LABEL
        });
    }
}
